import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';

import {
  useInvalidateNotificationsList,
  useInvalidateUnreadNotification,
} from '@/entities/notifications/queries';
import { markNotificationAsRead } from '@/shared/api/notifications';

export const useUpdateNotification = () => {
  const invalidateNotifs = useInvalidateUnreadNotification();
  const invalidateNofitsList = useInvalidateNotificationsList();

  const handleInvalidate = useCallback(() => {
    invalidateNotifs();
    invalidateNofitsList();
  }, [invalidateNofitsList, invalidateNotifs]);
  return {
    mutation: useMutation({
      mutationFn: (notificationId: string) =>
        markNotificationAsRead(notificationId),
    }),
    handleInvalidate,
  };
};
